__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@clusterio/controller";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@clusterio/lib", "2.0.0-alpha.18", () => (Promise.all([__webpack_require__.e(308), __webpack_require__.e(318), __webpack_require__.e(324)]).then(() => (() => (__webpack_require__(8370))))));
			register("@clusterio/web_ui", "2.0.0-alpha.18", () => (Promise.all([__webpack_require__.e(790), __webpack_require__.e(202), __webpack_require__.e(599), __webpack_require__.e(587), __webpack_require__.e(529)]).then(() => (() => (__webpack_require__(3864))))));
			register("antd", "5.13.0", () => (Promise.all([__webpack_require__.e(745), __webpack_require__.e(790), __webpack_require__.e(831), __webpack_require__.e(587)]).then(() => (() => (__webpack_require__(1745))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(730), __webpack_require__.e(599)]).then(() => (() => (__webpack_require__(3730))))));
			register("react-router-dom", "6.14.2", () => (Promise.all([__webpack_require__.e(367), __webpack_require__.e(569), __webpack_require__.e(212), __webpack_require__.e(279)]).then(() => (() => (__webpack_require__(1569))))));
			register("react-router", "6.14.2", () => (Promise.all([__webpack_require__.e(367), __webpack_require__.e(390), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(4390))))));
			register("react", "18.2.0", () => (__webpack_require__.e(983).then(() => (() => (__webpack_require__(2983))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};